import React from 'react';

const NightContext = React.createContext();

export default NightContext;